import moment from "moment";

export const FormatLogDate = (date?: string) => {
  if (!date) return { short: "-", full: "-" };

  return {
    short: moment(date).format("DD/MM/YYYY [às] HH:mm"),
    full: moment(date).format("DD/MM/YYYY [às] HH:mm:ss"),
  };
};